<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FphHcs/tc-custom/9781625671578.jpg?1724535328781" alt="This image is the cover for the book Three Quarters, Quarters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Three Quarters, Quarters
      </h1>
      <p class="bookDescription body article font2">
        <p>The Seven Armies’ deadliest blades are at their best in <i>Three Quarters</i>, a collection of three exciting shorts set in Tanya Huff’s Quarters universe.<br/><br/>In “Death Rites” sibling assassins Bannon and Vree must eliminate a dangerous traitor who’s already thwarted several other professionals.<br/><br/>In “Exactly,” Vree and Bannon slip surveillance shifts in between body rubs and drinks when they take a holiday, assassin-style. And in the novelette, “Quartered,” on Kovar’s orders, the young bard Evicka risks her life to spy on Vree and Gyhard in Bicaz.<br/><br/>Featuring an all-new foreword and new story introductions from the author, <i>Three Quarters</i> is sure to delight fans of The Quarters Series with Tanya Huff’s pitch-perfect harmony of adventure, intrigue, and wit.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tanya Huff
      </h2>
      
      <p class="authorDescription body article">Tanya Huff lives in rural Ontario with her wife Fiona Patton, five cats, and an increasing number of fish. Her 32 novels and 83 short stories include horror, heroic fantasy, urban fantasy, comedy, and space opera. Her BLOOD series was turned into the 22-episode <em>Blood Ties</em> and writing episode nine allowed her to finally use her degree in Radio & Television Arts. Many of her short stories are available as eCollections. She’s on Twitter at @TanyaHuff and Facebook as Tanya Huff. She has never used her Instagram account and isn’t sure why she has it.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?842cffb6